export const environment = {
  production: true,
  apiUrl: '/api',
  scopes: ['api://253ac816-9d47-4d05-8a43-91f4f37fc7ad/access_as_user'],
  redirectUri: 'https://app.vanhutech.org/auth-callback.html',
  postLogoutRedirectUri: 'https://app.vanhutech.org/',
  sentryRelease: 'vanhu-tech-web@1.0.6',
};
